import React, { useState, useEffect } from "react";
import { Menu } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { navLinks } from "../mock";
import ChaptersMenu from "./ChaptersMenu";

const Header = ({ variant = "light" }) => {
  const [chaptersOpen, setChaptersOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const isDark = variant === "dark" && !scrolled;
  const baseText = isDark ? "text-ink-on-dark" : "text-deep-taupe";
  const shell = isDark
    ? "bg-transparent border-transparent"
    : "bg-background-ivory/95 backdrop-blur-sm border-b border-hairline-beige";

  return (
    <>
      <header
        className={`fixed top-0 left-0 w-full z-50 flex justify-between items-center px-margin-mobile md:px-margin-desktop py-6 transition-all duration-500 ${shell}`}
      >
        <Link to="/" className="flex items-center" aria-label="The Kitchen Art Co.">
          <span
            className={`font-cormorant text-[26px] md:text-[28px] leading-none tracking-tight transition-colors duration-500 ${
              isDark ? "text-ink-on-dark" : "text-brand-ink"
            }`}
          >
            The Kitchen Art Co.<sup className="text-[0.5em] align-super tracking-normal ml-0.5">&reg;</sup>
          </span>
        </Link>

        <nav className="hidden md:flex gap-8 items-center">
          {navLinks.map((link) => {
            const active = pathname === link.to;
            return (
              <Link
                key={link.label}
                to={link.to}
                className={
                  active
                    ? "font-inter text-label-sm uppercase tracking-widest text-bright-gold-on-dark border-b border-bright-gold-on-dark pb-1 transition-all duration-300"
                    : `font-inter text-label-sm uppercase tracking-widest ${baseText} hover:text-bright-gold-on-dark transition-all duration-300`
                }
              >
                {link.label}
              </Link>
            );
          })}
        </nav>

        <div className="flex items-center gap-4">
          <Link
            to="/contact"
            className={`font-inter text-label-sm uppercase tracking-widest hover:text-bright-gold-on-dark hover:border-bright-gold-on-dark transition-all duration-300 hidden md:block border px-4 py-2 ${
              isDark
                ? "text-ink-on-dark border-ink-on-dark/50"
                : "text-brand-ink border-brand-gold"
            }`}
          >
            Let's Begin a Conversation
          </Link>
          <button
            onClick={() => setChaptersOpen(true)}
            aria-label="Open chapters menu"
            className={`flex items-center -m-2 p-2 transition-colors duration-300 ${
              isDark ? "text-ink-on-dark" : "text-brand-ink"
            } hover:text-bright-gold-on-dark`}
          >
            <Menu className="h-6 w-6" />
          </button>
        </div>
      </header>

      <ChaptersMenu open={chaptersOpen} onClose={() => setChaptersOpen(false)} />
    </>
  );
};

export default Header;
